import { ChangeDetectionStrategy, Component, OnDestroy } from "@angular/core";
import { IFloatingFilterAngularComp } from "ag-grid-angular";
import { IFloatingFilterParams, IFloatingFilterParent, IFilter, IMultiFilter } from "ag-grid-community";

@Component({
    selector: "sm-table-text-floating-filter",
    templateUrl: "./sm-table-text-floating-filter.component.html",
    styleUrl: "./sm-table-text-floating-filter.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class SmTableTextFloatingFilterComponent implements IFloatingFilterAngularComp<IMultiFilter>, OnDestroy {
    params: IFloatingFilterParams<IMultiFilter>;
    value = "";
    ariaLabel = "Filter";

    private filterType = "contains";
    private updateTimer: number = null;

    agInit(params: IFloatingFilterParams<IMultiFilter>): void {
        this.params = params;
        this.ariaLabel = (params.column.getColDef().headerName ?? "") + " Filter Input";
        this.onParentModelChanged(params.currentParentModel());
    }

    refresh(params: IFloatingFilterParams<IMultiFilter>): void {
        this.params = params;
        this.onParentModelChanged(params.currentParentModel());
    }

    onParentModelChanged(parentModel: any): void {
        let textFilterModel = parentModel?.filterModels?.[0];
        this.value = textFilterModel?.filter ?? "";
        this.filterType = textFilterModel?.filter == null ? "contains" : textFilterModel.type ?? "contains";
    }

    valueChanged(value: string): void {
        this.value = value;
        window.clearTimeout(this.updateTimer);
        this.updateTimer = window.setTimeout(() => this.applyFilter(), 300);
    }

    ngOnDestroy(): void {
        window.clearTimeout(this.updateTimer);
    }

    private applyFilter(): void {
        this.params.parentFilterInstance(parentFilter => {
            let textFilter = parentFilter.getChildFilterInstance<IFilter & IFloatingFilterParent>(0);
            textFilter?.onFloatingFilterChanged(this.filterType, this.value);
        });
    }
}
